import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=fb8f3ed6&"
import script from "./inbox.vue?vue&type=script&lang=ts&"
export * from "./inbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb8f3ed6')) {
      api.createRecord('fb8f3ed6', component.options)
    } else {
      api.reload('fb8f3ed6', component.options)
    }
    module.hot.accept("./inbox.vue?vue&type=template&id=fb8f3ed6&", function () {
      api.rerender('fb8f3ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/pm/inbox.vue"
export default component.exports